import { useRef } from 'react';
import { toPng } from 'html-to-image';
import { UserIcon } from '@heroicons/react/24/solid';

export default function Test() {
  const ref = useRef();

  const handleDownload = async () => {
    const dataUrl = await toPng(ref.current);
    const link = document.createElement('a');
    link.download = 'icon.png';
    link.href = dataUrl;
    link.click();
  };

  return (
    <>
      <div ref={ref} className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center">
        <UserIcon className="w-7 h-7 text-gray-500" />
      </div>
      <button onClick={handleDownload}>Download as PNG</button>
    </>
  );
}